import React from "react";
import { CountriesBadge } from "./CountriesBadge";
import { UserLinks } from "../UserLinks";
import { NameListUsers } from "./NameListUsers";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../shared/formatCurrency";


export const WalletsMergedTableColumns = (showInvested, totalInvested, totalAccount) => {
  const { t } = useTranslation();


  const getColumns = () => [
    {
      name: `${t('firstname')} ${t('lastname')}`,
      selector: (row) => <NameListUsers names={row.name_list} />,
      sortable: false,
      wrap: true,
      width: showInvested ? '50%' : '40%'
    },
    {
      name: "Wallet",
      selector: (row) => row.cc_addresses,
      sortable: true,
      width: '8%',
      center: true,
      cell: (row) => <a className="hover:bg-gray-400 mr-1" href={`https://usdt.tokenview.io/en/address/${row.cc_addresses}`} target="_blank" rel="noreferrer">{String(row.cc_addresses).slice(0, 5) || ""}</a>,
    },
    {
      name: "Ids",
      selector: (row) => row.user_ids,
      sortable: false,
      cell: (row) => (
        <UserLinks userIds={row.user_ids} />
      ),
    },
    {
      name: t('nacionalidad'),
      selector: (row) => row.country_code || "Unknown",
      sortable: true,
      center: true,
      cell: (row) => <CountriesBadge countries={row.country_code} />,
    },
    {
      name: t('withdrawn'),
      selector: (row) => Number(row.total_balance),
      right: true,
      sortable: true,
      cell: (row) => (
        <span className="text-red-600 font-semibold">
          {formatCurrency(row.total_balance)}
        </span>
      ),
    },
    {
      name: t('invested'),
      center: true,
      cell: (row, index) => (index === 0 &&
        <span className="text-green-600 font-semibold">
          {formatCurrency(totalInvested)}
        </span>
      ),
      omit: showInvested,
    },
    {
      name: t('total'),
      center: true,
      cell: (row, index) => (index === 0 &&
        <span className="font-semibold">
          {formatCurrency(totalAccount)}
        </span>
      ),
      omit: showInvested,
    },
  ]
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useMemo(() => getColumns(), [showInvested, totalInvested, totalAccount]);
};
